/* Copyright 2013 - 2024 Waiterio LLC */
import { useContext } from '@monorepo/context/index.js'
import getBrowserLanguage from '@monorepo/shared/getBrowserLanguage.js'
import useDocuments_ from '@supovia/react/useDocuments.js'

function useDocuments() {
  const [context] = useContext()
  let { websiteId } = context
  return useDocuments_({
    websiteId,
    locale: getBrowserLanguage(),
    fields: ['_id', 'title', 'content'],
  })
}

export default useDocuments
